import React from 'react';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable';
import { connect } from 'react-redux';
import GraphQLClient from 'graphql-js-client';
import types from '../../schema/types.js';
import Cart from './Cart';
import { settingsNextStep, settingsPrevStep, settingsSelectImage, settingsUpdateImage, settingsRemoveImage, settingsAddImageToCart, settingsRemoveImageFromCart, settingsReset } from '../../actions/settings';
import { loadProducts, clearProducts } from '../../actions/products';
import axios from 'axios';

class Wall extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      currentCollection: props.wallConfig.collections[0].id,
      showSearch: false,
      showLoadMore: false,
      showAdd: false,
      showSettings: false,
      addingProduct: null,
      addingProductData: null,
      editingImage: null,
      editingProduct: null,
      showHelp: false,
      showInspiration: false,
      showWarning: false,
      showShare: false,
      shareUrl: null,
      warningStep: null
    }
  }

  componentDidMount() {
    let csrfToken = document.getElementsByName('csrf-token')[0].getAttribute('content');
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
    //this.loadProducts();
    //let firstCollection = btoa(`gid://shopify/Collection/${this.props.wallConfig.collections[0].id}`);
    let firstCollection = this.props.wallConfig.collections[0].id;
    this.loadCollectionProducts(firstCollection);

    if(window.location.search.indexOf('product_1') > -1) {
      // click on background to make things load
      console.log('render click!');
      $('.background-wrapper').click();
      setTimeout(function() {
        $('.background-wrapper').click();
      }, 1000)
    }

    let _this = this;
    window.addEventListener('click', function(evt) {
      if(evt.target.closest('.help-modal') == null &&
        evt.target.closest('.inspiration-modal') == null &&
        evt.target.closest('.top-nav') == null) {
        _this.setState({
          showHelp: false,
          showInspiration: false
        })
      }
    })

    window.addEventListener('beforeunload', function() { alert('are you sure?') });

  }

  componentDidUpdate() {
    let _this = this;
    $( ".draggable" ).draggable({
      containment: ".background-wrapper",
      stop: function(event, ui) {
        _this.updateImageLocation(event.target, ui.position);
      }
    });
  }

  async getProduct(productId) {
    const client = new GraphQLClient(types, {
      url: `https://${this.props.shop.shopify_domain}/api/${this.props.settings.apiVersion}/graphql.json`,
      fetcherOptions: {
        headers: {
          'X-Shopify-Storefront-Access-Token': `${this.props.shop.storefront_token}`
        }
      }
    });

    const query = client.query((root) => {
      root.add('product', {args: {id: productId}}, (product) => {
        product.add('title');
        product.add('tags');
        product.add('availableForSale');
        product.addConnection('images', {args: {first: 1}}, (image) => {
          image.add('src');
          image.add('altText');
        });
        product.addConnection('variants', {args: {first: 100}}, (variant) => {
          variant.add('title');
          variant.add('price', (price) => {
            price.add('amount')
          })
          variant.add('availableForSale');
          variant.add('selectedOptions', (selectedOptions) => {
            selectedOptions.add('value');
          });
        })
      });
    });

    const response = await client.send(query).then(({model, data}) => {
      return data.product;
    })
    return {product: response}
  }

  prevStep() {
    this.props.settingsPrevStep();
  }

  moneyFormat(amount) {
    amount = amount.toString();
    let moneyFormat = this.props.shop.data.money_format;
    if(moneyFormat.indexOf('amount_with_comma_separator') > -1) {
      // replace commas and decimals
      let amountNoCommas = amount.replaceAll(',', '*');
      let amountChangedDecimal = amountNoCommas.replaceAll('.', ',');
      amount = amountChangedDecimal.replaceAll('*', '.');
    }
    let formattedAmount = moneyFormat.replace(/\{\{(.+?)\}\}/g, amount);
    return formattedAmount;
  }

  onToHomeClick(evt) {
    evt.preventDefault();
    this.setState({
      showWarning: true,
      alertStep: 'HOME'
    })
  }

  onWarningConfirm() {
    if(this.state.warningStep == 'HOME') {
      window.location.href = '/';
    } else if(this.state.warningStep == 'RESET') {
      this.setState({
        showWarning: false
      })
      this.props.settingsReset();
    }
  }

  onWarningCancel() {
    this.setState({
      showWarning: false,
      warningStep: null
    })
  }

  onReset() {
    this.setState({
      showWarning: true,
      warningStep: 'RESET'
    })
  }

  onShare() {
    console.log('share');
    let background = this.props.settings.background;
    let images = this.props.settings.images;
    let locX, locY;
    //let url = "https://" + this.props.shop.data.domain + "/apps/image-wall-dev?background=" + background.id + "&backgroundsrc=" + this.props.settings.backgroundSrc + "&foregroundsrc=" + this.props.settings.foregroundSrc;
    let url = "https://" + this.props.shop.data.domain + "/tools/image-wall?background=" + background.id + "&backgroundsrc=" + this.props.settings.backgroundSrc + "&foregroundsrc=" + this.props.settings.foregroundSrc;
    for(var i =0; i<images.length; i++) {
      locX = (images[i].left / $('.background-wrapper').width());
      locY = (images[i].top / $('.background-wrapper').height());
      url += "&product_" + (i + 1) + "=" + images[i].productId + "&variant_" + (i+1) + "=" + images[i].variantId + "&loc_" + (i+1) + "=" + locX + "x" + locY + "&frame_" + (i+1) + "=" + images[i].frame + "&frame_variant_" + (i+1) + "=" + images[i].frameVariant;
    }

    console.log(url);
    this.setState({
      showShare: true,
      shareUrl: url
    })
  }

  onShareCopy(url) {
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    $('#copiedText').css('opacity', 1)
    setTimeout(function() {
      $('#copiedText').css('opacity', 0);
    }, 2000)
  }

  onShareClose(evt) {
    evt.preventDefault();
    this.setState({
      showShare: false,
      shareUrl: null
    })
  }

  onShowHelp() {
    this.setState({
      showHelp: true
    })
  }

  onCloseHelp(evt) {
    evt.preventDefault();
    this.setState({
      showHelp: false
    })
  }

  onShowInspiration() {
    this.setState({
      showInspiration: true
    })
  }

  onCloseInspiration(evt) {
    evt.preventDefault();
    this.setState({
      showInspiration: false
    })
  }

  /*
  loadCollections(cursor = null) {
    console.log('collection cursor: ', cursor);
    const client = new GraphQLClient(types, {
      url: `https://${this.props.shop.shopify_domain}/api/graphql`,
      fetcherOptions: {
        headers: {
          'X-Shopify-Storefront-Access-Token': `${this.props.shop.storefront_token}`,
        }
      }
    });

    const query = client.query((root) => {
      root.addConnection('collections', {args: {first: 100, after: cursor}}, (collection) => {
        collection.add('title');
      });
    });

    let _this = this;
    let objects;
    client.send(query).then(({model, data}) => {
      this.setState({
        collections: data.collections.edges,
      })
    });
  }
  */

  onToggleSearch(evt) {
    evt.preventDefault();
    let showSearch = !this.state.showSearch;
    this.setState({
      showSearch: showSearch
    })
  }

  onSearchChange(evt) {
    if(evt.code == "Enter" || evt.charCode == 13) {
      this.setState({
        showLoadMore: false
      })
      this.onSearch();
    }
  }

  onSearch() {
    let _this = this;
    let query = $('#productSearch').val();
    $('#noSearchResults').css('opacity', 0);
    _this.props.clearProducts();
    const url = "https://api.clerk.io/v2/search/search?key=" + this.props.wallConfig.search_key.toString() + "&query=" + query + "&limit=1000&longtail=false&offset=0&order=asc&attributes=%5B%22id%22%2C%20%22name%22%2C%20%22image%22%2C%20%22stock%22%5D"
    const options = {
      method: 'GET',
      headers: {Accept: 'application/json'}
    };
    fetch(url, options)
      .then(response => response.json())
      .then(response => {
        if(response.product_data.length == 0) {
          // No results
          $('#noSearchResults').css('opacity', 1);
        } else {
          let filteredProducts = response.product_data.filter(product => product.stock > 0)
          let posters = filteredProducts.filter(product => (product.name.includes('plakat') || product.name.includes('Plakat') || product.name.includes('poster') || product.name.includes('Poster')));
          let productArray = posters.map(product => {
            return {
              productNumber: product.id,
              title: product.name,
              imgUrl: product.image
            }
          })
          _this.props.loadProducts(productArray);
        }
      })
      .catch(err => console.error(err));

    /*
    var options = {
      callback: function(data) {
        if(data.results == 0) {
          // No results
          $('#noSearchResults').css('opacity', 1);
        } else {
          let filteredProducts = data.result.filter(product => product.inStock)
          let posters = filteredProducts.filter(product => (product.title.includes('plakat') || product.title.includes('Plakat') || product.title.includes('poster') || product.title.includes('Poster')));
          _this.props.loadProducts(posters);
        }
      },
      format: "json",
      product_fields: "title,productNumber,imgUrl",
      engine_options: {
        product: {
          current_count: 1000,
          product_fields: "title,productNumber,imgUrl",
          start: 0
        },
      }
    };

    ADDWISH_PARTNER_NS.search.search(
      this.props.wallConfig.search_key.toString(), // the search config key
      query,
      options
    );
    */
  }

  onCollectionChange(evt) {
    //let collectionId = btoa(`gid://shopify/Collection/${evt.target.value}`)
    let collectionId = evt.target.value;
    this.props.clearProducts();
    this.loadCollectionProducts(collectionId, null);
    this.setState({
      currentCollection: collectionId
    })
  }

  loadMoreProducts(cursor) {
    this.loadCollectionProducts(this.state.currentCollection, cursor);
  }

  loadCollectionProducts(collectionId, cursor = null) {
    const client = new GraphQLClient(types, {
      url: `https://${this.props.shop.shopify_domain}/api/${this.props.settings.apiVersion}/graphql.json`,
      fetcherOptions: {
        headers: {
          'X-Shopify-Storefront-Access-Token': `${this.props.shop.storefront_token}`
        }
      }
    });

    //root.add('collection', {args: {id: collectionId}}, (collection) => {
    const query = client.query((root) => {
      root.add('collectionByHandle', {args: {handle: collectionId}}, (collection) => {
        collection.addConnection('products', {args: {first: 24, after: cursor}}, (product) => {
          product.add('title');
          product.add('tags');
          product.add('availableForSale');
          product.addConnection('images', {args: {first: 1}}, (image) => {
            image.add('src');
            image.add('altText');
          })
          product.addConnection('variants', {args: {first: 100}}, (variant) => {
            variant.add('title');
            variant.add('price', (price) => {
              price.add('amount')
            })
            variant.add('availableForSale');
            variant.add('selectedOptions', (selectedOptions) => {
              selectedOptions.add('value');
            });
          })
        })
      });
    });

    let _this = this;
    let objects;
    client.send(query).then(({model, data}) => {
      console.log(model, data);
      if(cursor == null) {
        this.props.clearProducts();
        this.props.loadProducts(data.collectionByHandle.products.edges);
      } else {
        this.props.loadProducts(data.collectionByHandle.products.edges);
      }
      this.setState({
        showLoadMore: data.collectionByHandle.products.pageInfo.hasNextPage
      })
    });
  }

  loadProducts(cursor = null) {
    const client = new GraphQLClient(types, {
      url: `https://${this.props.shop.shopify_domain}/api/${this.props.settings.apiVersion}/graphql.json`,
      fetcherOptions: {
        headers: {
          'X-Shopify-Storefront-Access-Token': `${this.props.shop.storefront_token}`,
        }
      }
    });

    const query = client.query((root) => {
      root.addConnection('products', {args: {first: 24, after: cursor}}, (product) => {
        product.add('title');
        product.add('availableForSale');
        product.addConnection('images', {args: {first: 1}}, (image) => {
          image.add('src');
          image.add('altText');
        })
        product.addConnection('variants', {args: {first: 100}}, (variant) => {
          variant.add('title');
          variant.add('price', (price) => {
            price.add('amount')
          })
          variant.add('availableForSale');
          variant.add('selectedOptions', (selectedOptions) => {
            selectedOptions.add('value');
          });
        })
      });
    });

    let _this = this;
    let objects;
    client.send(query).then(({model, data}) => {
      this.props.loadProducts(data.products.edges);
    });
  }

  onImageSelect(id) {
    let _this = this;
    this.getProduct(id).then((data) => {
      let addingProduct = data.product;
      console.log(addingProduct);
      let addVariant = addingProduct.variants.edges[0];
      if(addingProduct.variants.edges[2] != null) {
        addVariant = addingProduct.variants.edges[2];
      } else if(addingProduct.variants.edges[1] != null) {
        addVariant = addingProduct.variants.edges[1];
      }
      let addSize = addVariant.node.selectedOptions[0].value.split(' cm')[0]
      let addSizes = addSize.split('x');
      let addWidth = parseInt(addSizes[0]);
      let addHeight = parseInt(addSizes[1]);
      if(addingProduct.tags.indexOf('horizontal') > -1) {
        addHeight = parseInt(addSizes[0]);
        addWidth = parseInt(addSizes[1]);
      }
      let addTop = (($('.background-wrapper').height() / 2) - (4 * addHeight));
      let addLeft = (($('.background-wrapper').width() / 2) - addWidth);
      let addingImage = {
        productId: addingProduct.id,
        variantId: addVariant.node.id,
        src: addingProduct.images.edges[0].node.src,
        alt: addingProduct.title,
        width: addWidth,
        height: addHeight,
        top: addTop,
        left: addLeft,
        frame: "",
        frameVariant: "",
        variantPrice: parseFloat(addVariant.node.price.amount),
        framePrice: 0.0
      }
      console.log(addingImage);
      _this.setState({
        showAdd: true,
        addingProduct: addingImage,
        addingProductData: addingProduct
      })
    })
  }

  addImage(image) {
    this.props.settingsSelectImage(image);
    this.setState({
      showAdd: false,
      addingProduct: null
    })
  }

  onImageEdit(index) {
    let image = this.props.settings.images[index];
    let settingsTitle = image.alt.split(" -")[0];
    $('.image-settings__image').attr('src', image.src).attr('alt', image.alt);
    $('.image-settings__title').html(settingsTitle);
    this.getProduct(image.productId).then((data) => {
      this.setState({
        showSettings: true,
        editingImage: index,
        editingProduct: data.product
      })
    })
  }

  onEditSave() {
    this.setState({
      showAdd: false,
      addingProduct: null,
      showSettings: false,
      editingImage: null,
      editingProduct: null
    })
  }

  onSettingsDismiss(evt) {
    let $target = $(evt.target);
    if(!$target.hasClass('poster') && $target.parents('.poster').length == 0 && !$target.hasClass('image-settings') && $target.parents('.image-settings').length == 0) {
      this.setState({
        showAdd: false,
        addingProduct: null,
        showSettings: false,
        editingImage: null,
        editingProduct: null
      })
    }
  }

  updateImageLocation(target, position) {
    let targetIndex = $(target).data('index');
    let image = this.props.settings.images[targetIndex];
    image.top = position.top;
    image.left = position.left;
    this.props.settingsUpdateImage(targetIndex, image);
  }

  onAddVariantChange(evt) {
    let variantId = evt.target.value;
    let variant;
    let isHorizontal = false;
    for(var i=0; i < this.state.addingProductData.variants.edges.length; i++) {
      if(this.state.addingProductData.variants.edges[i].node.id == variantId) {
        variant = this.state.addingProductData.variants.edges[i];
        if(this.state.addingProductData.tags.indexOf('horizontal') > -1) {
          isHorizontal = true;
        }
      }
    }
    let variantPrice = parseFloat(variant.node.price.amount);
    let framePrice = 0.0;
    let size = variant.node.selectedOptions[0].value.split(' cm')[0]
    let sizes = size.split('x');
    let width = parseInt(sizes[0]);
    let height = parseInt(sizes[1]);
    if(isHorizontal) {
      height = parseInt(sizes[0]);
      width = parseInt(sizes[1]);
    }
    let revSize = height.toString() + "x" + width.toString() + " cm";

    let image = this.state.addingProduct;
    // check for a valid frame. Set values if it exists, or remove it
    if(image.frame != "" && image.frame != null) {
      let currentFrame;
      for(let frame of this.props.frames) {
        if(frame.id == image.frame) {
          currentFrame = frame;
        }
      }
      let foundFrame = false;
      for(let frameVariant of currentFrame.product_data.variants) {
        if(frameVariant.selectedOptions[0].value == variant.node.selectedOptions[0].value || frameVariant.selectedOptions[0] == revSize) {
          foundFrame = true;
          image.frameVariant = frameVariant.id;
          framePrice += parseFloat(frameVariant.price);
        }
      }
      if(!foundFrame) {
        image.frame = "";
        image.frameVariant = "";
      }
    }

    image.width = width;
    image.height = height;
    image.variantId = variantId;
    image.variantPrice = variantPrice;
    image.framePrice = framePrice;
    this.setState({
      addingProduct: image
    })
  }

  onVariantChange(index, evt) {
    let variantId = evt.target.value;
    let variant;
    let isHorizontal = false;
    for(var i=0; i<this.state.editingProduct.variants.edges.length; i++) {
      if(this.state.editingProduct.variants.edges[i].node.id == variantId) {
        variant = this.state.editingProduct.variants.edges[i];
        if(this.state.editingProduct.tags.indexOf('horizontal') > -1) {
          isHorizontal = true;
        }
      }
    }
    let totalPrice = parseFloat(variant.node.price.amount);
    let variantPrice = parseFloat(variant.node.price.amount);
    let framePrice = 0.0;
    let size = variant.node.selectedOptions[0].value.split(' cm')[0]
    let sizes = size.split('x');
    let width = parseInt(sizes[0]);
    let height = parseInt(sizes[1]);
    if(isHorizontal) {
      height = parseInt(sizes[0]);
      width = parseInt(sizes[1]);
    }
    let revSize = height.toString() + "x" + width.toString() + " cm";

    let image = this.props.settings.images[index];
    // check for a valid frame. Set values if it exists, or remove it
    if(image.frame != "" && image.frame != null) {
      let currentFrame;
      for(let frame of this.props.frames) {
        if(frame.id == image.frame) {
          currentFrame = frame;
        }
      }
      let foundFrame = false;
      for(let frameVariant of currentFrame.product_data.variants) {
        if(frameVariant.selectedOptions[0].value == variant.node.selectedOptions[0].value || frameVariant.selectedOptions[0].value == revSize) {
          foundFrame = true;
          image.frameVariant = frameVariant.id;
          framePrice += parseFloat(frameVariant.price);
        }
      }
      if(!foundFrame) {
        image.frame = "";
        image.frameVariant = "";
      }
    }

    image.width = width;
    image.height = height;
    image.variantId = variantId;
    image.variantPrice = variantPrice;
    image.framePrice = framePrice;
    this.props.settingsUpdateImage(index, image);
    /*
    let widthStyle = (width * 3.0).toString() + "px";
    let id = "poster" + index;
    let wrapper = evt.target.parentElement.parentElement;

    wrapper.style.width = widthStyle;
    */
  }

  onAddFrameChange(image) {
    //let $selectedOption = $(evt.target.options[evt.target.selectedIndex]);
    let $selectedOption = $('input[name="frameVariant"]:checked')
    let variantId = $selectedOption.data('variant-id');
    let frameId = $selectedOption.data('frame-id');
    let framePrice = 0.0;
    if(frameId != null && frameId != "") {
      for(let i=0; i < this.props.frames.length; i++) {
        if(this.props.frames[i].id == frameId) {
          for(let j=0; j < this.props.frames[i].product_data.variants.length; j++) {
            if(this.props.frames[i].product_data.variants[j].id == variantId) {
              framePrice = parseFloat(this.props.frames[i].product_data.variants[j].price);
            }
          }
        }
      }
    }
    image.frame = frameId;
    image.frameVariant = variantId;
    image.framePrice = framePrice;
    console.log(image);
    this.setState({
      addingProduct: image
    })
  }

  onFrameChange(index, evt) {
    //let $selectedOption = $(evt.target.options[evt.target.selectedIndex]);
    let $selectedOption = $('input[name="frameVariant"]:checked')
    let variantId = $selectedOption.data('variant-id');
    let frameId = $selectedOption.data('frame-id');
    let image = this.props.settings.images[index];
    let framePrice = 0.0;
    if(frameId != null && frameId != "") {
      for(let i=0; i < this.props.frames.length; i++) {
        if(this.props.frames[i].id == frameId) {
          for(let j=0; j < this.props.frames[i].product_data.variants.length; j++) {
            if(this.props.frames[i].product_data.variants[j].id == variantId) {
              framePrice = parseFloat(this.props.frames[i].product_data.variants[j].price);
            }
          }
        }
      }
    }
    image.frame = frameId;
    image.frameVariant = variantId;
    image.framePrice = framePrice;
    this.props.settingsUpdateImage(index, image);
  }

  removeImage(index) {
    this.setState({
      showSettings: false,
      editingImage: null,
      editingProduct: null
    })
    this.props.settingsRemoveImage(index);
  }

  addWallToCart() {
    console.log('add wall products to cart');
    for(let i=0; i<this.props.settings.images.length; i++) {
      this.props.settingsAddImageToCart(this.props.settings.images[i]);
    }
    setTimeout(function() {
      $('.cart').addClass('active');
    }, 300);
  }

  viewCart(evt) {
    evt.preventDefault();
    $('.cart').addClass('active');
  }

  render() {
    console.log("FRAMES: ", this.props.frames);
    let _this = this;
    let productList;
    if(this.props.products.length > 0) {
      productList = this.props.products.map((product) => {
        let productImage;
        if(product.node != undefined) {
          if(product.node.images.edges[0] != undefined) {
            productImage = product.node.images.edges[0].node.src;
          }
        } else {
          if(product.imgUrl != undefined) {
            productImage = product.imgUrl;
          }
        }
        let productId;
        let productTitle;
        if(product.productNumber != undefined) {
          // Product from search
          productId = btoa("gid://shopify/Product/" + product.productNumber.toString());
          productTitle = product.title;
        } else {
          productId = product.node.id;
          productTitle = product.node.title;
        }
        return(
          <div className="product col-6" key={productId} onClick={this.onImageSelect.bind(this, productId)}>
            <div className="product__image-wrapper d-flex justify-content-center align-items-center">
              <img className="product__image" src={productImage} alt={productTitle} />
            </div>
            <p className="product__title">{productTitle.split(" -")[0]}</p>
            <button className="product__add btn btn--primary col-12">{this.props.wallConfig.add_btn_text}</button>
          </div>
        )
      })
    } else {
      productList = (
        <div className="empty-product-list col-12 text-center">
          <h3 id="noSearchResults" className="search-no-results-text mt-5">{this.props.wallConfig.search_no_results}</h3>
        </div>
      )
    }
    let productCursor = null;
    if(this.props.products.length) {
      if(this.props.products[0].productNumber == undefined) {
        productCursor = this.props.products[this.props.products.length - 1].cursor;
      }
    }
    let loadMoreButton = null;
    if(this.state.showLoadMore) {
      loadMoreButton = (<button className="load-products text-center btn btn--primary btn--large" data-cursor={productCursor} onClick={this.loadMoreProducts.bind(this, productCursor)}>{this.props.wallConfig.load_more_text}</button>);
    }
    let assetList = (
      <div className="product-container d-flex flex-wrap">
        {productList}
        <div className="product-list__load-more-wrapper col-12 text-center my-3">
          {loadMoreButton}
        </div>
      </div>
    )

    let images = this.props.settings.images.map((image, index) => {
      let sizeString = image.width.toString() + "x" + image.height.toString() + " cm";
      let revSizeString = image.height.toString() + "x" + image.width.toString() + " cm";
      let posterStyle = {
        top: image.top + 'px',
        left: image.left + 'px',
        //width: (image.width * 4.0) + 'px'
        width: (image.width / 410.0) * 100.0 + '%'
      }
      let frameStyle = {};
      let frameImage = "";
      if(image.frame != "") {
        let framePadding = "3px";
        if(image.width >= 30 && image.width < 50) {
          framePadding = "3px";
        } else if(image.width >= 50 && image.width < 70) {
          framePadding = "3px";
        } else if(image.width >= 70) {
          framePadding = "3px";
        }
        for(let frame of this.props.frames) {
          if(frame.id == image.frame) {
            frameStyle = {
              padding: framePadding
            };
            frameImage = (<img className="poster__frame-image" src={frame.src} alt={frame.title} />);
          }
        }
      }
        /*
          <div className="poster__variant-selector">
            <select id="" className="poster__variants" name="" onChange={this.onVariantChange.bind(this, index)}>
              {variants}
            </select>
            <select id="" className="poster__frames" name="" value={image.frame} onChange={this.onFrameChange.bind(this, index)}>
              <option value="" data-img-src="">None</option>
              {frameOptions}
            </select>
            <p className="poster__remove" onClick={this.removeImage.bind(this, index)}>remove</p>
          </div>
          */
      return(
        <div className="poster draggable" key={'poster' + index} id={'poster' + index} data-index={index} style={posterStyle}>
          <div className="poster__edit-wrapper">
            <p className="poster__edit btn" onClick={this.onImageEdit.bind(this, index)}>
              <img className="edit-button__icon" src={this.props.editIcon} alt="edit" />
            </p>
            <p className="poster__remove btn" onClick={this.removeImage.bind(this, index)}>X</p>
          </div>
          <div className="poster__image-wrapper" style={frameStyle}>
            {frameImage}
            <img className="poster__image" src={image.src} alt={image.alt} />
          </div>
        </div>
      )
    })

    let backgroundSrc = {backgroundImage: 'url("' + this.props.settings.backgroundSrc + '")'};
    let foregroundSrc = {backgroundImage: 'url("' + this.props.settings.foregroundSrc + '")'};
    let backgroundDiv = (
      <div className="background-wrapper room-wrapper col-12 p-0" style={backgroundSrc}>
        {images}
        <div className="wall-foreground" style={foregroundSrc}></div>
      </div>
    )

    let settingsClass = "image-settings col-3 text-center";
    let variantPrice;
    let variants;
    let frameOptions;
    let variantId;
    let frameId;
    let frameVariant;
    let framePrice = 0;
    let totalPrice;
    let settingsImage;
    let settingsImageAlt;
    if(this.state.showAdd) {
      settingsClass = "image-settings col-3 text-center active";
      let editingImage = this.state.addingProduct;
      let sizeString = editingImage.width.toString() + "x" + editingImage.height.toString() + " cm";
      let revSizeString = editingImage.height.toString() + "x" + editingImage.width.toString() + " cm";
      variantId = editingImage.variantId;
      frameId = editingImage.frame;
      frameVariant = editingImage.frameVariant;
      settingsImage = editingImage.src;
      settingsImageAlt = editingImage.alt;
      console.log(this.state.addingProductData);
      let availableVariants = this.state.addingProductData.variants.edges.filter(variant => variant.node.availableForSale);
      variants = availableVariants.map((variant, index2) => {
        if(editingImage.variantId == variant.node.id) {
          variantPrice = parseFloat(variant.node.price.amount);
          return(
            <label>
              <input type="radio" name="sizeVariant" value={variant.node.id} onChange={this.onAddVariantChange.bind(this)} checked/>
              {variant.node.title} <span className="image-settings__price">{this.moneyFormat(variant.node.price.amount)}</span>
            </label>
          )
        } else {
          return(
            <label>
              <input type="radio" name="sizeVariant" value={variant.node.id} onChange={this.onAddVariantChange.bind(this)} />
              {variant.node.title} <span className="image-settings__price">{this.moneyFormat(variant.node.price.amount)}</span>
            </label>
          )
        }
      })

      // Frame dropdown
      frameOptions = this.props.frames.map((frame, index) => {
        for(let variantFrame of frame.product_data.variants) {
          if(variantFrame.id.toString() == frameVariant.toString()) {
            framePrice = parseFloat(variantFrame.price)
          }
          if(variantFrame.selectedOptions[0].value == sizeString || variantFrame.selectedOptions[0].value == revSizeString) {
            let frameImage = {backgroundImage: 'url("' + frame.src + '")'};
            return(
              <label>
                <span>
                  <input type="radio" name="frameVariant" value={variantFrame.id} data-frame-id={frame.id} data-variant-id={variantFrame.id} data-img-src={frame.src} onChange={this.onAddFrameChange.bind(this, this.state.addingProduct)} />
                  {frame.title}
                </span>
                <div className="frame-option__image" style={frameImage}></div>
              </label>
            )
          }
        }
      })
    }
    if(this.state.showSettings) {
      settingsClass = "image-settings col-3 text-center active";
      let editingImage = this.props.settings.images[this.state.editingImage];
      let sizeString = editingImage.width.toString() + "x" + editingImage.height.toString() + " cm";
      let revSizeString = editingImage.height.toString() + "x" + editingImage.width.toString() + " cm";
      variantId = editingImage.variantId;
      frameId = editingImage.frame;
      frameVariant = editingImage.frameVariant;
      let availableVariants = _this.state.editingProduct.variants.edges.filter(variant => variant.node.availableForSale);
      variants = availableVariants.map((variant, index2) => {
        if(editingImage.variantId == variant.node.id) {
          variantPrice = parseFloat(variant.node.price.amount);
          return(
            <label>
              <input type="radio" name="sizeVariant" value={variant.node.id} onChange={this.onVariantChange.bind(this, this.state.editingImage)} checked/>
              {variant.node.title} <span className="image-settings__price">{this.moneyFormat(variant.node.price.amount)}</span>
            </label>
          )
        } else {
          return(
            <label>
              <input type="radio" name="sizeVariant" value={variant.node.id} onChange={this.onVariantChange.bind(this, this.state.editingImage)} />
              {variant.node.title} <span className="image-settings__price">{this.moneyFormat(variant.node.price.amount)}</span>
            </label>
          )
        }
      })

      // Frame dropdown
      frameOptions = this.props.frames.map((frame, index) => {
        for(let variantFrame of frame.product_data.variants) {
          if(variantFrame.id == frameVariant) {
            framePrice = parseFloat(variantFrame.price)
          }
          if(variantFrame.selectedOptions[0].value == sizeString || variantFrame.selectedOptions[0].value == revSizeString) {
            let frameImage = {backgroundImage: 'url("' + frame.src + '")'};
            if(frameVariant.toString() == variantFrame.id.toString()) {
              return(
                <label>
                  <span>
                    <input type="radio" name="frameVariant" value={variantFrame.id} data-frame-id={frame.id} data-variant-id={variantFrame.id} data-img-src={frame.src} onChange={this.onFrameChange.bind(this, this.state.editingImage)} checked />
                    {frame.title}
                  </span>
                  <div className="frame-option__image" style={frameImage}></div>
                </label>
              )
            } else {
              return(
                <label>
                  <span>
                    <input type="radio" name="frameVariant" value={variantFrame.id} data-frame-id={frame.id} data-variant-id={variantFrame.id} data-img-src={frame.src} onChange={this.onFrameChange.bind(this, this.state.editingImage)} />
                    {frame.title}
                  </span>
                  <div className="frame-option__image" style={frameImage}></div>
                </label>
              )
            }
          }
        }
      })
    }
    totalPrice = variantPrice + framePrice;
    let noFrameRadio = (<input type="radio" name="frameVariant" value="" data-variant-id="" data-img-src="" onChange={this.onFrameChange.bind(this, this.state.editingImage)}/>);
    let addRemoveButton = (
      <div className="image-settings__total-buttons-wrapper">
        <div className="image-settings__total-price-wrapper d-flex justify-content-between align-items-center">
          <h4 className="image-settings__total-price">{this.props.wallConfig.add_price_text}</h4>
          <h4 className="image-settings__total-amount">{this.moneyFormat(totalPrice)}</h4>
        </div>
        <button className="image-settings__save btn btn--primary col-12" onClick={this.onEditSave.bind(this)}>{this.props.wallConfig.save_btn_text}</button>
        <button className="image-settings__add btn btn--secondary col-12" onClick={this.removeImage.bind(this, this.state.editingImage)}>{this.props.wallConfig.remove_btn_text}</button>
      </div>
    );
    if(this.state.showAdd) {
      addRemoveButton = (
        <div className="image-settings__total-buttons-wrapper">
          <div className="image-settings__total-price-wrapper d-flex justify-content-between align-items-center">
            <h5 className="image-settings__total-price">{this.props.wallConfig.add_price_text}</h5>
            <h5 className="image-settings__total-amount">{this.moneyFormat(totalPrice)}</h5>
          </div>
          <button className="image-settings__add btn btn--primary col-12" onClick={this.addImage.bind(this, this.state.addingProduct)}>{this.props.wallConfig.add_btn_text}</button>
        </div>
      );
      noFrameRadio = (<input type="radio" name="frameVariant" value="" data-variant-id="" data-img-src="" onChange={this.onAddFrameChange.bind(this, this.state.addingProduct)}/>);
    }
    let settingsTitle = null;
    if(this.state.addingProduct != null) {
      settingsTitle = this.state.addingProduct.alt.split(" -")[0];
    }
    /*
        <div className="image-settings__price-wrapper d-flex justify-content-between">
          <h4 className="image-settings__price">Price</h4>
          <h4 className="image-settings__price">{variantPrice}kr</h4>
        </div>
     */
    let imageSettings = (
      <div className={settingsClass}>
        <img className="image-settings__image" src={settingsImage} alt={settingsImageAlt} />
        <h5 className="image-settings__title font--large">{settingsTitle}</h5>
        <div className="image-settings__size-wrapper">
          <label className="text-start image-settings__size-label" for="imageSettingsVariants">{this.props.wallConfig.add_size_text}</label><br />
          <div className="image-settings__sizes">
            {variants}
          </div>
        </div>
        <div className="image-settings__frames-wrapper">
          <label className="text-start image-settings__frame-label" for="imageSettingsFrames">{this.props.wallConfig.add_frame_text}</label><br />
          <div className="image-settings__frames">
            <label>
              <span>
                {noFrameRadio}
                {this.props.wallConfig.no_frame}
              </span>
              <div className="frame-option__image">X</div>
            </label>
            {frameOptions}
          </div>
        </div>
        {addRemoveButton}
      </div>
    )

    let cartButton = "";
    if(this.props.settings.images.length > 0) {
      cartButton = (<button className="add-to-cart__button btn btn--primary btn--large" onClick={this.addWallToCart.bind(this)}>{this.props.wallConfig.add_wall_to_cart_text}</button>);
    }
    /*
          <button className="menu__item btn btn--link" onClick={this.onShare.bind(this)}>Share</button>
     */
    let helpModal = null;
    if(this.state.showHelp) {
      let faqs = this.props.faqs.map((faq) => {
        return(
          <li className="help-modal__faq" key={"faq-" + faq.id}>
            <div className="help-modal__question">
              <a href={"#faq-" + faq.id} data-toggle="collapse" data-target={"#faq-" + faq.id}>
                <h5>{faq.question}</h5>
              </a>
            </div>
            <div className="help-modal__answer collapse" id={"faq-" + faq.id}>
              <p>{faq.answer}</p>
            </div>
          </li>
        )
      })
      helpModal = (
        <div className="help-modal">
          <a className="help-modal__close" href="#" onClick={this.onCloseHelp.bind(this)}>X</a>
          <div className="help-modal__title text-center">
            <h4>{this.props.wallConfig.help_title}</h4>
          </div>
          <div className="help-modal__body">
            <ul className="help-modal__faq-list">
              {faqs}
            </ul>
          </div>
        </div>
      )
    }
    let shareModal = null;
    if(this.state.showShare) {
      shareModal = (
        <div className="share-modal">
          <a className="share-modal__close" href="#" onClick={this.onShareClose.bind(this)}>X</a>
          <div className="share-modal__content text-center">
            <p className="font--large">{this.props.wallConfig.share_title}</p>
            <h3>{this.props.wallConfig.share_content}</h3>
          </div>
          <div className="share-modal__button-wrapper">
            <button className="btn btn--large btn--primary" onClick={this.onShareCopy.bind(this, this.state.shareUrl)}>{this.props.wallConfig.share_button_text}</button>
          </div>
          <p id="copiedText">{this.props.wallConfig.copied_text}</p>
        </div>
      )
    }

    let inspirationModal = null
    if(this.state.showInspiration) {
      let insp_text = this.props.wallConfig.insp_text.replaceAll('<a', '<a target="_blank"');
      inspirationModal = (
        <div className="inspiration-modal">
          <a className="inspiration-modal__close" href="#" onClick={this.onCloseInspiration.bind(this)}>X</a>
          <div className="inspiration-modal__title text-center">
            <h4>{this.props.wallConfig.insp_title}</h4>
            <div></div>
          </div>
          <div className="inspiration-modal__content"  dangerouslySetInnerHTML={{__html: insp_text}}></div>
        </div>
      )
    }

    let warningModal = null;
    if(this.state.showWarning) {
      warningModal = (
        <div className="warning-modal">
          <div className="warning-modal__content text-center">
            <p className="font--large">
              {this.props.wallConfig.warning_title}
            </p>
            <h3>
              {this.props.wallConfig.warning_text}
            </h3>
            <div className="warning-modal__button-wrapper">
              <button className="btn btn--large btn--primary" onClick={this.onWarningConfirm.bind(this)}>{this.props.wallConfig.warning_continue}</button>
              <button className="btn btn--large btn--secondary" onClick={this.onWarningCancel.bind(this)}>{this.props.wallConfig.warning_cancel}</button>
            </div>
          </div>
        </div>
      )
    }

    let menu = (
      <div className="add-to-cart menu d-flex justify-content-between align-items-center">
        <div className="menu__items-wrapper d-flex justify-content-start align-items-center">
          <button className="menu__item btn btn--large btn--primary" onClick={this.onReset.bind(this)}>{this.props.wallConfig.create_btn_text}</button>
          <button className="menu__item btn btn--large btn--primary mx-3" onClick={this.onShare.bind(this)}>{this.props.wallConfig.share_btn_text}</button>
        </div>
        {cartButton}
      </div>
    )

    let sortedCollections = this.props.wallConfig.collections.sort((a,b) => (parseInt(a.position) > parseInt(b.position)) ? 1 : -1)
    let collectionOptions = sortedCollections.map((collection, index) => {
      let title = collection.title;
      if(index == 0) {
        title = this.props.wallConfig.dropdown_title;
      }
      return(
        <option value={collection.id}>{title}</option>
      )
    })
    let search = null;
    if(this.state.showSearch) {
      search = (
        <div className="search__wrapper">
          <input id="productSearch" className="search" type="text" placeholder={this.props.wallConfig.search_text} onKeyPress={this.onSearchChange.bind(this)} autoFocus/>
        </div>
      );
    }
    let cartButtonDot;
    if(this.props.settings.cart.length) {
      cartButtonDot = (<span class="cart-button-dot"></span>);
    }
    return(
      <div className="container-fluid image-wall d-none d-lg-block d-xl-block">
        <div className="row">
          <div className="settings-column col-lg-2 d-flex flex-column px-0">
            <a className="settings-column__logo-link text-center" href="/" onClick={this.onToHomeClick.bind(this)}>
              <img className="settings-column__logo" src={this.props.wallConfig.logo_url} alt="Visse Vasse" />
            </a>
            <div className="collection-search px-3 d-flex justify-content-between align-items-center flex-wrap">
              <select id="" className="collections text-center" name="collection" onChange={this.onCollectionChange.bind(this)}>
                {collectionOptions}
              </select>
              <a className="search__trigger" href="#" onClick={this.onToggleSearch.bind(this)}>
                <img className="search-trigger__icon" src={this.props.searchIcon} alt="Search" />
              </a>
              {search}
            </div>
            {assetList}
            <div className="button-wrapper px-3 d-flex">
              <button className="background-next text-center btn btn--large btn--secondary" onClick={this.prevStep.bind(this)}>{this.props.wallConfig.back_btn_text}</button>
            </div>
          </div>
          <div className="background-column col-lg-10 px-0" onClick={this.onSettingsDismiss.bind(this)}>
            <div className="top-nav">
              <button className="btn btn--primary btn--large" onClick={this.onShowHelp.bind(this)}>{this.props.wallConfig.help_btn_text}</button>
              <button className="btn btn--primary btn--large mx-3" onClick={this.onShowInspiration.bind(this)}>{this.props.wallConfig.insp_btn_text}</button>
            </div>
            <a className="cart-button" href="#" onClick={this.viewCart.bind(this)}>
              <img className="cart-button__icon" src={this.props.cartIcon} alt="cart" />
              {cartButtonDot}
            </a>
            {imageSettings}
            {backgroundDiv}
            {helpModal}
            {shareModal}
            {inspirationModal}
            {warningModal}
            {menu}
            <Cart />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  shop: state.shop,
  wallConfig: state.wallConfig,
  settings: state.settings,
  products: state.products,
  backgrounds: state.backgrounds,
  frames: state.frames,
  faqs: state.faqs
})

const mapDispatchToProps = {
  clearProducts,
  loadProducts,
  settingsPrevStep,
  settingsNextStep,
  settingsSelectImage,
  settingsUpdateImage,
  settingsRemoveImage,
  settingsAddImageToCart,
  settingsRemoveImageFromCart,
  settingsReset
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Wall);
